var map = {
	"./de.json": "wjNP",
	"./en.json": "Om/e",
	"./es.json": "JOJI",
	"./fr.json": "rqa7",
	"./it.json": "G87Z",
	"./mx.json": "isNi",
	"./pt.json": "Dkfp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lJCM";